<template>
    <div class="about">
        <div class="about-box">
            <!-- <van-overlay class="out-box" :show="ZheZhaoShow">
				<van-loading v-show="loadingShow" color="red" size="100" />
			</van-overlay> -->

            <!-- <div class="Me-box">
				<div class="headportrait-box">
					<div class="headportrait">
						<template v-if="user.anchor_icon ==1">
							<div class=anchor_icon>	</div>
							<img class=pic_icon :src="user.avatar" alt="">
						</template>
						<template v-else-if="user.anchor_icon ==2">
							<div class="anchor_icon_gf">	</div>
							<img class="pic_icon" :src="user.avatar" alt="">
						</template>
						<template v-else>
							<img class=pic_icon style="border: 1px solid #fff;" :src="user.avatar" alt="">
							<img v-if="user.vipLevel != 0" class=pic_vip :src="GetVipIcon(user.vipLevel)" alt="">
						</template>

					</div>

					<my-upload :key="menuKey" @crop-success="cropSuccess" v-model="show" :width="200" :height="200" img-format="png"
					 :size="size" langType='zh' :noRotate='false' field="Avatar1"></my-upload>

                    <button class="btn" @click="CertificationShow">实名认证</button>
					<button class="btn" @click="toggleShow">设置头像</button>
				</div>
				<div class="Me-item">
					<p>Steam_id</p>
					<div class="box-item-info">{{steam_id}}</div>
				</div>
				<div class="Me-item">
					<p>Steam交易链接</p>
					<input type="text" v-model="steam_url" placeholder="绑定成功后无法修改" v-if='hasSteamURL==false'>
					<div class="box-item-info" v-else>{{steam_url}}</div>
					<div class="btn" @click="GetSteamUrl" v-if='hasSteamURL==false'>保存</div>
					
				</div>
				<div class="Me-item">
					<p>昵称</p>
					<input type="text" v-model="Name">
					<div class="btn" @click="PostName">保存</div>
				</div>
				<div class="Me-item">
					<p>邀请码</p>
					<div class="box-item-info">{{invite_code}}</div>
				</div>
				<div class="Me-item">
					<p>绑定邀请码</p>
					
					<input type="text" v-if="inviter_id == 0" v-model="invite_code_bangding" placeholder="请输入绑定邀请码">
					<div class="btn" @click="setinvite_code" v-if="inviter_id == 0">修改</div>
					
					<div class="box-item-info" v-if="inviter != null">{{inviter.invite_code}}</div>
					<div class="btn" v-if="inviter_id !== 0"></div>
					
					<div class="tip">绑定邀请码只可修改一次</div>
				</div>
				<div class="Me-item">
					<p>Email地址</p>
					<div class="box-item-info">{{Email}}</div>
				</div>
				<div class="Me-item">
					<p>注册时间</p>
					<div class="box-item-info">{{created_at}}</div>
				</div>
				<div class="Me-item">
					<p>上次活动时间</p>
					<div class="box-item-info">{{updated_at}}</div>
				</div>
			</div> -->



            <div class="me">
                <van-overlay class="out-box" :show="ZheZhaoShow">
				    <van-loading v-show="loadingShow" color="red" size="100" />
			    </van-overlay>
                <my-upload :key="menuKey" @crop-success="cropSuccess" v-model="show" :width="200" :height="200" img-format="png"
					 :size="size" langType='zh' :noRotate='false' field="Avatar1"></my-upload>

                <div class="top_info">
                    <div class="header_info">
                        <div class="me_header">
                            <img class="icon_img" :src="user.avatar" alt="">
                        </div>
                        <div class="txt_edit" @click="toggleShow">
                            更改头像
                        </div>

                    </div>
                    <div class="top_info_wrap">
                        <div class="info_item">
                            <div class="item_t">
                                昵称
                            </div>
                            <div class="item_c">
                                {{ user.name }}
                            </div>
                            <div class="item_btn" @click="ModifyTickNameShow">
                                修改昵称
                            </div>
                        </div>
                        <div class="info_item">
                            <div class="item_t">
                                ID
                            </div>
                            <div class="item_c">
                                {{ my_user_id }}
                            </div>
                            <div class="item_btn">
                                复制ID
                            </div>
                        </div>
                        <div class="info_item">
                            <div class="item_t">
                                手机
                            </div>
                            <div class="item_c">{{ replaceStr(user.mobile) }}</div>
                            <div class="item_btn" @click="ModifyPasswordShow">修改密码</div>
                        </div>
                        <div class="info_item">
                            <div class="item_t">
                                金币
                            </div>
                            <div class="item_price">
                                <img class="price_coin" src="@/assets/images/PublicImg/JinBi.png" alt="">
                                {{ user.bean }}
                            </div>
                            <div class="item_btn" @click="Recharge">
                                充值
                            </div>
                        </div>
                    </div>

                    <div class="top_opt_wrap">
                        <div class="top_opt_item" @click="CertificationShow">
                            <div class="icon_switch">
                                <img src="@/assets/images/NavHeader/XiuG.png" alt="">
                            </div>
                            <template v-if="my_idcard.length < 2">
                                <template v-if="my_anchor ==1">
                                    已认证
                                </template>
                                <template v-else>
                                    实名认证
                                </template>
                            </template>
                            <template v-else>
                                已认证
                            </template>

                        </div>
                        <div class="top_opt_item" @click="MyInviteCodeShow">
                            <div class="icon_switch">
                                <img src="@/assets/images/NavHeader/XiuG.png" alt="">
                            </div>
                            我的邀请码
                        </div>
                        <div class="top_opt_item" @click="MyInviteCodeBindShow">
                            <div class="icon_switch">
                                <img src="@/assets/images/NavHeader/XiuG.png" alt="">
                            </div>
                            绑定邀请码
                        </div>
                        <div class="top_opt_item" @click="ModifySteamUrlShow">
                            <div class="icon_switch">
                                <img src="@/assets/images/NavHeader/XiuG.png" alt="">
                            </div>
                            Steam交易链接
                        </div>
                    </div>

                </div>
                <!-- 库存,个人明细...... -->
                <div class="top_tabs">
                    <div class="top_tab_item" :class="{ 'active': my_tab_index == 1 }" @click="ChangeTabs(1)">
                        <img src="@/assets/images/new-ui/nav8-n.png" alt="" />
                        库存
                    </div>
                    <div class="top_tab_item" :class="{ 'active': my_tab_index == 2 }" @click="ChangeTabs(2)">
                        个人明细
                    </div>
                    <div class="top_tab_item" :class="{ 'active': my_tab_index == 3 }" @click="ChangeTabs(3)">
                        推广分红
                    </div>
                    <div class="top_tab_item" :class="{ 'active': my_tab_index == 4 }" @click="ChangeTabs(4)">
                        站内信息
                    </div>
                    <div class="top_tab_item" :class="{ 'active': my_tab_index == 5 }" @click="ChangeTabs(5)">
                        帮助中心
                    </div>
                    <div class="tab_vip" :class="{ 'active': my_tab_index == 6 }" @click="ChangeTabs(6)">
                        成为优质会员
                        <img src="@/assets/images/NavHeader/mvip4.png" alt="" />
                    </div>
                </div>
                <div class="me_content_wrap">

                    <template v-if="my_tab_index == 1">
                        <MyBag></MyBag>
                    </template>
                    <template v-else-if="my_tab_index == 2">
                        <MyRecord></MyRecord>
                        
                    </template>
                    <template v-else-if="my_tab_index == 3">
                        <MyExtension></MyExtension>

                    </template>
                    <template v-else-if="my_tab_index == 4">
                    </template>
                    <template v-else-if="my_tab_index == 5">
                        <Help></Help>
                    </template>
                    <template v-else-if="my_tab_index == 6">
                        <MyVip></MyVip>
                    </template>
                </div>
            </div>

            <!-- 实名认证 -->
            <van-overlay :show="certification_show">
                <div class="wrapper">
                    <div class="certification_wrap">
                        <div class="close" @click="CertificationClose">
                            <img src="@/assets/images/NavHeader/close.png" alt="">
                        </div>
                        <div class="title">实名认证</div>
                        <div class="input_wrap">
                            <input type="text" v-model="user_real_name" placeholder="请输入您的姓名">
                        </div>
                        <div class="input_wrap">
                            <input type="text" v-model="user_name_card" placeholder="请输入您的身份证号">
                        </div>
                        <div class="btn" @click="RealName">立即认证</div>
                    </div>
                </div>
            </van-overlay>

            <!-- 我的邀请码 -->
            <van-overlay :show="my_invite_code_show">
                <div class="wrapper">
                    <div class="certification_wrap">
                        <div class="close" @click="MyInviteCodeClose">
                            <img src="@/assets/images/NavHeader/close.png" alt="">
                        </div>
                        <div class="title">我的邀请码</div>
                        <div class="input_wrap">
                            <input type="text" v-model="my_invite_code" placeholder="">
                            <div class="btn_sure">
                                <img class="icon_check" src="@/assets/images/OpenBox/active2.png" alt="">
                            </div>
                        </div>

                    </div>
                </div>
            </van-overlay>

            <!-- 绑定邀请码 -->
            <van-overlay :show="my_invite_code_bind_show">
                <div class="wrapper">
                    <div class="certification_wrap">
                        <div class="close" @click="MyInviteCodeBindClose">
                            <img src="@/assets/images/NavHeader/close.png" alt="">
                        </div>
                        <div class="title">绑定邀请码</div>
                        <div class="input_wrap">

                            <!-- <input type="text" v-if="inviter_id == 0" v-model="invite_code_bangding" placeholder="请输入绑定邀请码">
					<div class="btn" @click="setinvite_code" v-if="inviter_id == 0">修改</div>
					
					<div class="box-item-info" v-if="inviter != null">{{inviter.invite_code}}</div>
					<div class="btn" v-if="inviter_id !== 0"></div> -->

                            <template v-if="inviter_id ==0">
                                <input type="text" v-model="my_invite_code_bind" placeholder="请输入绑定邀请码">
                                <div class="btn_sure" @click="MySetInviteCode">
                                    <img class="icon_check" src="@/assets/images/OpenBox/active2.png" alt="">
                                </div>
                            </template>
                            <template v-else>

                                <input type="text" v-model="inviter.invite_code" disabled>
                                <div class="btn_sure">
                                    <img class="icon_check" src="@/assets/images/OpenBox/active2.png" alt="">
                                </div>

                            </template>


                        </div>

                        <div class="tip">*绑定邀请码只可修改一次</div>

                    </div>
                </div>
            </van-overlay>

            <!-- 修改steam交易链接 -->
            <van-overlay :show="modify_steam_url_show">
                <div class="wrapper">
                    <div class="certification_wrap">
                        <div class="close" @click="ModifySteamUrlClose">
                            <img src="@/assets/images/NavHeader/close.png" alt="">
                        </div>
                        <div class="title">
                            绑定交易链接
                            <div class="title_opt">
                                跳转STEAM链接
                            </div>
                        </div>
                        <div class="input_wrap">
                            <input type="text" v-model="my_steam_url" placeholder="">
                            <div class="btn_sure" @click="SetSteamUrl">
                                <img class="icon_check" src="@/assets/images/OpenBox/active2.png" alt="">
                            </div>
                        </div>
                        <div class="tip">*交易链接绑定后无法更改，请谨慎操作</div>

                    </div>
                </div>
            </van-overlay>

            <!-- 修改昵称 -->
            <van-overlay :show="modify_nickname_show">
                <div class="wrapper">
                    <div class="certification_wrap">
                        <div class="close" @click="ModifyTickNameClose">
                            <img src="@/assets/images/NavHeader/close.png" alt="">
                        </div>
                        <div class="title">修改昵称</div>

                        <div class="input_wrap">
                            <input type="text" v-model="user_nickname" placeholder="请输入昵称">
                            <div class="btn_sure" @click="PostTickName">
                                <img class="icon_check" src="@/assets/images/OpenBox/active2.png" alt="">
                            </div>
                        </div>

                    </div>
                </div>
            </van-overlay>

            <!-- 修改密码 -->
            <van-overlay :show="modify_password_show">
                <div class="wrapper">
                    <div class="certification_wrap">
                        <div class="close" @click="ModifyPasswordClose">
                            <img src="@/assets/images/NavHeader/close.png" alt="">
                        </div>
                        <div class="title">修改密码</div>

                        <div class="input_wrap">
                            <input type="text" v-model="modify_mobile" placeholder="请输入手机号">
                        </div>
                        <div class="input_wrap">
                            <input type="text" v-model="modify_verify" placeholder="请输入验证码">
                            <div class="btn_verify" @click="ModifyPostSendSms" v-show="modify_verification_show == false">
                                发送验证码
                            </div>
                            <div class="btn_verify" v-show="modify_verification_show == true">
                                已发送
                                <van-count-down :time="modify_time" class="CLR" format="ss" :auto-start="false"
                                    @finish="ModifyFinish" ref="countDown" />
                            </div>
                        </div>
                        <div class="input_wrap">
                            <input type="password" v-model="modify_password" placeholder="请输入新密码">
                        </div>
                        <div class="btn" @click="ConfirmModification">确定</div>
                    </div>
                </div>
            </van-overlay>



        </div>
    </div>
</template>
<script>
import {
    PersonalInfo,
    SteamUrl,
    Set_avatar,
    base64,
    Set_Name,
    set_inviter,
    Identification,
    Reset_password,
    PostSendSms,
} from '@/network/api.js'
import {
    mapState,
    mapMutations
} from 'vuex'
import myUpload from 'vue-image-crop-upload';
import MyBag from './MyBag/index.vue'
import MyExtension from './MyExtension/index.vue'
import Help from './Help/index.vue'
import MyVip from './MyVip/index.vue'
import MyRecord from './MyRecord/index.vue'


export default {
    name: 'about',

    data() {
        return {
            menuKey: 1,
            show: false,
            size: 2.1,

            ZheZhaoShow: false,
            loadingShow: true,

            Name: '',
            invite_code: '',
            Email: '',
            created_at: '',
            updated_at: '',

            steam_url: '',
            vipLevel: 0,
            hasSteamURL: false,
            steam_id: '',
            invite_code_bangding: '',
            inviter_id: 0,  ///邀请人id
            inviter: null,


            ///选中的页签
            my_tab_index: 1, ///1:库存 2:个人明细 3:推广分红 4:站内信息 5: 帮助中心 6: 成为优质会员

            ///----------------------------------------
            ///实名认证窗口
            certification_show: false,
            user_real_name: "",//真实姓名
            user_name_card: "",

            ///----------------------------------------
            //我的邀请码
            my_invite_code_show: false,
            my_invite_code: "",

            ///----------------------------------------
            ///绑定邀请码
            my_invite_code_bind_show:false,
            my_invite_code_bind:"",


            ///----------------------------------------
            ///修改steam交易链接
            modify_steam_url_show: false,
            my_steam_url: "",


            ///----------------------------------------
            ///修改昵称窗口
            modify_nickname_show: false,
            user_nickname: "",


            ///----------------------------------------
            ///修改密码
            modify_password_show: false,
            modify_mobile: "",
            modify_verify: "",
            modify_password: "",

            modify_verification_show: false, ///验证码cd
            modify_time: 60 * 1000,
            ///----------------------------------------

            my_mobile: "",   ///手机号
            my_idcard: "0",  ///实名
            my_user_id: "",  ///用户id
            my_anchor:0,    

        }
    },

    created() {
        this.GetPersonalInfo();
    },

    components: {
        "my-upload": myUpload,
        MyBag,
        MyExtension,
        Help,
        MyVip,
        MyRecord,
    },

    methods: {

        replaceStr(str) {
            if (str) {
                if (str.length >= 11) {
                    let temp = str.substr(7, 4);
                    return "*******" + temp;
                }
                else {
                    return str;
                }
            }

        },


        ///页签切换
        ChangeTabs(tab) {
            this.my_tab_index = tab;
        },
        RealName() {
            if (!this.user_real_name) {
                this.$message({
                    message: '请输入姓名',
                    type: 'error'
                })
                return;
            }
            if (!this.user_name_card) {
                this.$message({
                    message: '请输入身份证号',
                    type: 'error'
                })
                return;
            }

            Identification(this.user_real_name, this.user_name_card).then((res) => {
                if (res.data.code == 200) {
                    this.GetPersonalInfo();
                    this.$message({
                        message: '验证成功',
                        type: 'success'
                    })
                } else {
                    this.$message({
                        message: res.data.message,
                        type: '验证失败'
                    })
                }
            })

        },

        GetVipIcon(level) {
            if (level == 1) {
                return require('@/assets/images/vip/VIP-1.png');
            } else if (level == 2) {
                return require('@/assets/images/vip/VIP-2.png');
            } else if (level == 3) {
                return require('@/assets/images/vip/VIP-3.png');
            } else if (level == 4) {
                return require('@/assets/images/vip/VIP-4.png');
            } else if (level == 5) {
                return require('@/assets/images/vip/VIP-5.png');
            }
            else if (level == 6) {
                return require('@/assets/images/vip/VIP-6.png');
            }
            else if (level == 7) {
                return require('@/assets/images/vip/VIP-7.png');
            }
            else if (level == 8) {
                return require('@/assets/images/vip/VIP-8.png');
            }
            else if (level == 9) {
                return require('@/assets/images/vip/VIP-9.png');
            }
            else if (level == 10) {
                return require('@/assets/images/vip/VIP-10.png');
            }
            else if (level == 11) {
                return require('@/assets/images/vip/VIP-11.png');
            }
            else if (level == 12) {
                return require('@/assets/images/vip/VIP-12.png');
            }
            return require('@/assets/images/vip/VIP-1.png');
        },


        GetPersonalInfo() {
            PersonalInfo().then((res) => {
                this.steam_id = res.data.message.steam_id
                this.Name = res.data.message.name
                this.invite_code = res.data.message.invite_code
                this.vipLevel = res.data.message.vipLevel
                this.Email = res.data.message.email
                this.created_at = res.data.message.created_at
                this.updated_at = res.data.message.updated_at
                this.steam_url = res.data.message.steam_url
                if (this.steam_url != '')
                    this.hasSteamURL = true;

                this.inviter_id = res.data.message.inviter_id   ///邀请人id
                this.inviter = res.data.message.inviter

                ///使用新的
                this.my_invite_code = res.data.message.invite_code;
                this.my_steam_url = res.data.message.steam_url;
                this.my_mobile = res.data.message.mobile;
                this.my_idcard = res.data.message.idcard;
                this.my_user_id = res.data.message.id;
                
                this.my_anchor = res.data.message.anchor;


            })
        },

        PostName() {
            Set_Name(this.Name).then((res) => {
                this.$message({
                    message: res.data.message,
                    type: 'success'
                })

                PersonalInfo().then((res) => {
                    this.User(res.data.message)
                })
            })
        },

        setinvite_code() {
            set_inviter(this.invite_code_bangding).then(res => {
                this.$message({
                    message: res.data.message,
                    type: 'success'
                })
                this.GetPersonalInfo()
            })
        },

        GetSteamUrl() {
            SteamUrl(this.steam_url).then((res) => {
                if (res.data.code == 200) {
                    this.hasSteamURL = true;
                    this.$message({
                        message: res.data.message,
                        type: 'success'
                    })
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    })
                }
            })
        },

        toggleShow() {
            this.show = !this.show;
        },

        Recharge(){
            this.$router.push('/Recharge');
        },
 

        ///实名认证
        CertificationShow() {
            if (this.my_idcard.length > 2 || this.my_anchor==1) {
                return;
            }

            this.certification_show = true;
        },
        CertificationClose() {
            this.certification_show = false;
        },

        ///邀请码
        MyInviteCodeShow() {
            this.my_invite_code_show = true;
        },
        MyInviteCodeClose() {
            this.my_invite_code_show = false;
        },

        ///绑定邀请码
        MyInviteCodeBindShow() {
            this.my_invite_code_bind_show = true;
        },
        MyInviteCodeBindClose() {
            this.my_invite_code_bind_show = false;
        },
        MySetInviteCode() {
            set_inviter(this.my_invite_code_bind).then(res => {
                this.$message({
                    message: res.data.message,
                    type: 'success'
                })
                this.GetPersonalInfo();
            })
        },


        ///steam url
        ModifySteamUrlShow() {
            this.modify_steam_url_show = true;
        },
        ModifySteamUrlClose() {
            this.modify_steam_url_show = false;
        },
        SetSteamUrl() {
            SteamUrl(this.my_steam_url).then((res) => {
                if (res.data.code == 200) {
                    this.hasSteamURL = true;
                    this.$message({
                        message: res.data.message,
                        type: 'success'
                    })
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    })
                }
            })
        },


        ///修改昵称
        ModifyTickNameShow() {
            this.modify_nickname_show = true;
        },
        ModifyTickNameClose() {
            this.modify_nickname_show = false;
        },
        PostTickName() {
            Set_Name(this.user_nickname).then((res) => {
                this.$message({
                    message: res.data.message,
                    type: 'success'
                })

                PersonalInfo().then((res) => {
                    this.User(res.data.message)
                })
            })
        },

        ///修改密码
        ModifyPasswordShow() {
            this.modify_password_show = true;
        },
        ModifyPasswordClose() {
            this.modify_password_show = false;
        },

        //发送验证码
        ModifyPostSendSms() {
            if (this.modify_mobile != "") {
                this.modify_verification_show = true;
                this.$refs.countDown.start();
                PostSendSms(this.modify_mobile, 3).then((res) => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        })
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        })
                    }
                })
            } else {
                this.$message({
                    message: '请输入手机号',
                    type: 'error'
                })
            }
        },
        ModifyFinish() {
            this.modify_verification_show = false;
            this.$refs.countDown.reset();
        },

        ConfirmModification() {
            Reset_password(this.modify_mobile, this.modify_password, this.modify_verify).then((res) => {
                if (res.data.code == 200) {
                    this.$message({
                        message: '修改成功,请重新登录',
                        type: 'success'
                    })
                    this.SignOut();
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    })
                }
            })
        },


        cropSuccess(imgDataUrl, field) {
            this.ZheZhaoShow = true
            base64(imgDataUrl).then((res) => {
                Set_avatar(res.data.data.url).then((res) => {
                    PersonalInfo().then((res) => {
                        this.User(res.data.message)
                        this.ZheZhaoShow = false
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        })
                    })
                })
            })
            ++this.menuKey
            this.show = false
        },

        SignOut() {
            this.GetIndividualsShow(false);
            this.Leave();
            this.$router.push('/');
            this.modify_mobile = '';
            this.modify_password = '';
            this.modify_verify = '';
            this.modify_password_show = false;
        },

        ...mapMutations([
            'User',
            'Leave',
            'GetIndividualsShow'
        ])

    },


    computed: {
        ...mapState([
            'user'
        ])
    },
    watch: {
        user(v) {
            console.log(v)
        }

    }
}
</script>
<style lang="scss">
.about-box {
    width: 100%;

    .CLR {
        font-size: 13px;
        color: #ffffff;
    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .certification_wrap {
        width: 560px;
        min-height: 205px;
        background: #191C34;
        position: relative;
        box-sizing: border-box;
        color: #fff;
        padding: 49px 70px 60px;
        display: flex;
        flex-direction: column;

        .close {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            position: absolute;
            right: 10px;
            top: 10px;
            cursor: pointer;
        }

        .title {
            color: #fff;
            font-size: 21px;
            margin-bottom: 25px;
            display: flex;
            align-items: center;

            .title_opt {
                display: flex;
                height: 44px;
                width: 145px;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                background: rgba(89, 224, 159, .03);
                color: #61f4ab;
                font-size: 14px;
                font-weight: 700;
                margin-left: 20px;
            }
        }

        .input_wrap {
            display: flex;
            width: 100%;
            height: 44px;
            border-bottom: 1px solid #3A34B0;
            margin-bottom: 10px;

            input {
                flex: 1;
                border: none;
                background: none;
                box-sizing: border-box;
                font-size: 17px
            }

            .btn_sure {
                display: flex;
                width: 32px;
                height: 32px;
                justify-content: center;
                align-items: center;
                border-radius: 10px;
                background: #3A34B0;
                cursor: pointer;

                .icon_check {
                    display: inline-block;
                    vertical-align: middle;
                    fill: currentColor;
                    width: 14px;
                    height: 10px;
                    color: #fff;
                    position: relative;
                }
            }

            .btn_verify {
                display: flex;
                width: 84px;
                height: 30px;
                justify-content: center;
                align-items: center;
                border-radius: 2px;
                background: #404BB4;
                color: #e0def4;
                font-size: 13px;
                line-height: 30px;
                cursor: pointer;
            }

        }

        .tip {
            color: orange;
            font-size: 14px;
            margin-top: 9px;
        }

        .btn {
            width: 110px;
            height: 40px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
            background: #404BB4;
            user-select: none;
            margin: 10px auto 0;
            font-size: 13px;
        }
    }

    .me {
        max-width: 1400px;
        min-height: 900px;
        width: 100%;
        box-sizing: border-box;

        .top_info {
            width: 100%;
            height: 288px;
            background: #111324;
            margin-top: 25px;
            position: relative;
            overflow: hidden;
            display: flex;
            align-items: center;

            .header_info {
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                width: 300px;
                height: 100%;

                .me_header {
                    width: 130px;
                    height: 130px;
                    position: relative;

                    .icon_img {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        border-radius: 20px;
                        overflow: hidden;
                        box-sizing: border-box;
                    }
                }

                .txt_edit {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    display: inline-flex;
                    width: 112px;
                    height: 32px;
                    border-radius: 18.519px;
                    background: #3A34B0;
                    bottom: 60px;
                    cursor: pointer;
                }
            }

            .top_info_wrap {
                display: flex;
                flex-direction: column;

                .info_item {
                    display: flex;
                    align-items: center;
                    height: 45px;

                    .item_t {
                        color: #cbcbcb;
                        font-size: 20px;
                        font-weight: 700;
                        width: 60px;
                        margin-right: 20px;
                    }

                    .item_c {
                        color: #cbcbcb;
                        font-size: 20px;
                        font-weight: 700;
                        width: 156px;
                        margin-right: 30px;
                    }

                    .item_price {
                        color: #FFD077;
                        font-size: 20px;
                        font-family: 'Oxanium';
                        width: 156px;
                        margin-right: 30px;
                        display: flex;
                        align-items: center;
                        line-height: 10px;

                        .price_coin {

                            width: 22px;
                            height: 22px;
                        }
                    }

                    .item_btn {
                        display: flex;
                        width: 84px;
                        height: 30px;
                        justify-content: center;
                        align-items: center;
                        border-radius: 2px;
                        background: #404BB4;
                        color: #e0def4;
                        font-size: 13px;
                        cursor: pointer;
                    }
                }
            }

            .top_opt_wrap {
                padding-left: 102px;
                border-left: 1px solid #24274E;
                margin-left: 88px;
                display: grid;
                flex-wrap: wrap;
                grid-template-columns: repeat(auto-fill, 220px);
                column-gap: 56px;
                row-gap: 26px;
                height: 151px;
                flex: 1;

                .top_opt_item {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 220px;
                    height: 60px;
                    cursor: pointer;
                    border-radius: 6px;
                    background: #181A31;
                    position: relative;
                    color: #dfdfdf;
                    margin: auto;

                    .icon_switch {
                        width: 18px;
                        height: 18px;
                        margin-right: 30px;
                        position: relative;

                        img {
                            width: 18px;
                            height: 18px;
                        }
                    }

                    &:hover {
                        background: #0A0B16;
                    }
                }
            }
        }

        ///库存,明细......
        .top_tabs {
            width: 100%;
            height: 80px;
            display: flex;
            background: #111324;
            color: #e0def4;
            font-size: 16px;
            font-weight: 400;
            margin-top: 24px;

            .top_tab_item {
                display: flex;
                align-items: center;
                justify-content: center;
                white-space: nowrap;
                flex-grow: 1;
                padding-left: 15px;
                padding-right: 15px;
                height: 80px;
                padding-top: 3px;
                font-size: 16px;
                color: #9ca1c7;
                font-weight: 500;
                text-align: left;
                background-color: #111324;
                border-right: 1px solid #1f213b;
                border-bottom: 1px solid transparent;
                transition: color .15s, border-color .15s;
                box-sizing: border-box;
                cursor: pointer;

                &.active {
                    color: #e0def4;
                    background-color: #404bb4;
                }
            }

            .tab_vip {
                display: flex;
                align-items: center;
                color: #fff;
                font-size: 16px;
                line-height: 1;
                padding: 13px 12px 12px 16px;
                background-image: linear-gradient(-111deg, #5c0feb 0, #ce40ed 100%);
                flex-grow: 1;
                font-weight: 700;
                white-space: nowrap;
                border-radius: 0 3px 3px 0;
                justify-content: center;
            }
        }

        ///数据
        .me_content_wrap {}
    }



    .out-box {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .Me-box {
        width: 10rem;
        margin: 0.4rem auto 0;

        .headportrait-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .btn {
                width: 1rem;
                height: 0.4rem;
                background: rgba($color: #fff, $alpha: .1);
                border: 1px solid #fff;
                border-radius: 0.04rem;
                text-align: center;
                line-height: 0.4rem;
                cursor: pointer;
            }

            .vicp-wrap {
                background: #353535;

                .vicp-icon4 {
                    display: none;
                }

                .vicp-drop-area {
                    background: #2f2f2f;
                }

                .vicp-operate {
                    width: 100%;
                    height: 0.4rem;
                    display: flex;
                    justify-content: flex-end;

                    a {
                        float: none;
                        margin: 0 0 0 0.2rem;
                        display: block;
                        width: 1rem;
                        height: 0.4rem;
                        background: rgba($color: #fff, $alpha: .1);
                        border: 1px solid #fff;
                        border-radius: 0.04rem;
                        text-align: center;
                        line-height: 0.4rem;
                        cursor: pointer;
                        color: #fff;
                        font-size: 0.16rem;
                    }

                }
            }

            .headportrait {
                height: 100%;
                position: relative;

                .pic_icon {
                    width: 1rem;
                    height: 1rem;
                    border-radius: 50%;
                    margin: 0 auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                        //transition: .3s;
                    }
                }

                .anchor_icon {
                    width: 1rem;
                    height: 1rem;
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 10;
                    background: url(../../assets/images/vip/anchor.png) no-repeat 0;
                    background-size: 100% 100%;
                }

                .anchor_icon_gf {
                    width: 1rem;
                    height: 1rem;
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 10;
                    background: url(../../assets/images/vip/gf.png) no-repeat 0;
                    background-size: 100% 100%;
                }

                .pic_vip {
                    width: .8rem;
                    height: .8rem;
                    position: absolute;
                    left: 0.5rem;
                    top: 0.4rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 10;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                        //transition: .3s;
                    }
                }

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .Me-item {
            width: 100%;
            height: 0.95rem;
            border-top: 0.01rem solid #25284b;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 0.15rem;
            position: relative;

            .tip {
                position: absolute;
                bottom: 10px;
                font-size: 14px;
                left: 280px;
                color: rgb(255, 211, 34);
            }

            p {
                width: 1.2rem;
            }

            input {
                width: 5.3rem;
                height: 0.4rem;

                border: none;
                outline: red;
                border-radius: 0.04rem;
                padding: 0 0.15rem;
                box-sizing: border-box;
                font-size: 0.13rem;
                color: #fff;

                &:focus {
                    background: rgba($color: #fff, $alpha: .1);
                    border: 1px solid #fff;
                }
            }

            .btn {
                width: 0.7rem;
                height: 0.4rem;
                background: rgba($color: #fff, $alpha: .1);
                border: 1px solid #fff;
                border-radius: 0.04rem;
                text-align: center;
                line-height: 0.4rem;
                cursor: pointer;
            }

            .box-item-info {
                width: 7.4rem;
                height: 0.4rem;

                line-height: 0.4rem;
                padding-left: 0.2rem;
                box-sizing: border-box;
                font-size: 0.13rem;
            }
        }
    }
}
</style>
